var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('l-marker',{attrs:{"lat-lng":[
    _vm.locationData.coordinates.latitude,
    _vm.locationData.coordinates.longitude,
  ]},on:{"click":_vm.pinClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }